<template>
  <ul class="moDetail-content">
    <li>
      <span>提单人：</span>
      <span>{{moDdetail.createdBy}}</span>
    </li>
    <li>
      <span>物料单号：</span>
      <span>{{moDdetail.moNumber}}</span>
    </li>
    <li>
      <span>物料单类型：</span>
      <span v-if="moDdetail.moType==1">订单</span>
      <span v-if="moDdetail.moType==2">样品</span>
      <span v-if="moDdetail.moType==3">外借</span>
    </li>
    <li>
      <span>物料单状态：</span>
      <span v-if="moDdetail.moStatus==0">待出货</span>
      <span v-if="moDdetail.moStatus==1">已出货</span>
      <span v-if="moDdetail.moStatus==2">已撤销</span>
    </li>
    <li>
      <span>子系统类型：</span>
      <span v-if="moDdetail.systemType==1">太阳能</span>
      <span v-if="moDdetail.systemType==2">市电</span>
    </li>
    <li>
      <span>子系统名称：</span>
      <span>{{getSystemName(moDdetail.systemId)}}</span>
    </li>
    <li>
      <span>物料信息：</span>
      <span>{{moDdetail.materialInfo}}</span>
    </li>
    <li>
      <span>计费周期：</span>
      <span>{{moDdetail.endUseTime | time}}</span>
    </li>
    <li>
      <span>收件信息：</span>
      <span>{{moDdetail.receiptInfo}}</span>
    </li>
    <li>
      <span>快递信息：</span>
      <span>{{moDdetail.expressInfo}}</span>
    </li>
    <li>
      <span>提单时间：</span>
      <span>{{moDdetail.createdAt | time}}</span>
    </li>
    <li>
      <span>出货时间：</span>
      <span>{{moDdetail.shipmentTime | time}}</span>
    </li>
    <li>
      <span>出货截止时间：</span>
      <span>{{moDdetail.latestShipmentTime | time}}</span>
    </li>
    <li>
      <span>备注：</span>
      <span>{{moDdetail.createdBy}}</span>
    </li>
  </ul>
</template>

<script>
import http from 'http';

export default {
  name: 'meterailDetail',
  data () {
    return {
      systemList: []
    };
  },
  props: ['moDdetail'],
  methods: {
    getSystemName (id) {
      // return this.systemList.filter(item => item.id === id)[0].name;
      let systemInfo = this.systemList.filter(item => item.id === id)[0];
      if (systemInfo) {
        return systemInfo.name;
      } else {
        return '--';
      }
    },
    // 获取子系统
    async getSystemList () {
      let { data } = await http.get('/v1/sub-systems');
      this.systemList = data;
    }
  },
  created () {
    this.getSystemList();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/monitor/detail.vue